(ns frontend.view.modals.textarea.events
  (:require [clojure.string :as string]))

(defn form-not-ready? [state]
  (string/blank? (:value @state)))

(defn no-changes? [state* original-value]
  (= (:value @state*)
     original-value))

(defn reset-state! [state]
  (reset! state {}))
